<template>
  <div>
    <div class="backBtnBox">
      <a-button type="primary" @click="backTap"> 返回 </a-button>
    </div>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item label="手机号">
                <a-input
                  placeholder="请输入手机号"
                  v-model="searchObj.mobileNumber"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="姓名">
                <a-input
                  placeholder="请输入姓名"
                  v-model="searchObj.memberName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="是否激活">
                <a-select
                  style="width: 155px"
                  placeholder="请选择激活状态"
                  v-model="searchObj.isActivate"
                  v-decorator="[
                  'benefitType',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择激活状态',
                      },
                    ],
                  },
                ]"
                >
                  <a-select-option v-for="item in isList" :key="item.id" :value="item.id">{{
                    item.name
                    }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
              >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
              >重置</a-button
              >
            </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        <a-button type="primary" icon="import" @click="exportFile">导入</a-button>
        <!-- 高级查询区域 -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down"
          /></a-button>
        </a-dropdown>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          size="middle"
          :scroll="{ x: true }"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
          class="j-table-force-nowrap"
          @change="handleTableChange"
        >
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
          >无图片</span
          >
            <img
              v-else
              :src="getImgView(text)"
              height="25px"
              alt=""
              style="max-width: 80px; font-size: 12px; font-style: italic"
            />
          </template>
          <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
          >无文件</span
          >
            <a-button
              v-else
              :ghost="true"
              type="primary"
              icon="download"
              size="small"
              @click="downloadFile(text)"
            >
              下载
            </a-button>
          </template>

          <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        </a-table>
      </div>

      <a-modal title="上传文件" :visible="exportVisible" @ok="handleOk" @cancel="handleCancel">
        <form action="">
          <a-form-item label="上传文件">
            <a-upload
              name="file"
              :multiple="true"
              accept=".xls,.xlsx"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :remove="handleRemove"
            >
              <a-button> <a-icon type="upload" />选择文件</a-button>
            </a-upload>

            <a
              @click="handleExportExcel('机构会员')"
              href="javascript:;"
              style="padding-left: 10px"
            >点击下载模板</a
            >
          </a-form-item>
        </form>
      </a-modal>

      <ct-mo-member-modal
        ref="modalForm"
        :organizationId="organizationId"
        @ok="modalFormOk"
      ></ct-mo-member-modal>
    </a-card>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less';
import CtMoMemberModal from './modules/CtMoMemberModal';
import { filterObj } from '@/utils/util';
import { getAction,postAction,uploadAction,downFile } from '@/api/manage';
const columns = [
  {
    title: '#',
    dataIndex: '',
    key: 'rowIndex',
    width: 60,
    align: 'center',
    customRender: function (t, r, index) {
      return parseInt(index) + 1;
    },
  },
  {
    title: '机构名称',
    align: 'center',
    dataIndex: 'organizationName',
  },
  {
    title: '会员姓名',
    align: 'center',
    dataIndex: 'memberName',
  },
  {
    title: '手机号',
    align: 'center',
    dataIndex: 'mobileNumber',
  },
  {
    title: 'unionid',
    align: 'center',
    dataIndex: 'unionid',
  },
  {
    title: '是否激活',
    align: 'center',
    dataIndex: 'isActivate_dictText',
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 147,
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  inject: ['closeCurrent'],
  name: 'CtMoMemberList',
  components: {
    CtMoMemberModal,
  },
  data() {
    return {
      exportVisible: false,
      fileList: [],
      organizationId: '',
      isList: [
        { id: 0, name: '否' },
        { id: 1, name: '是' },
      ],
      description: '机构管理页面',
      //--------列表页重复代码 start-------------
      searchObj: {
        organizationId: "",
        isActivate: "",
        memberName: "",
        mobileNumber: "",
      },
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* table选中keys*/
      selectedRowKeys: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      //--------列表页重复代码 end-------------
      // 表头
      columns,
      url: {
        list:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organizationMember/ctMoMember/getPageList',
        delete:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organizationMember/ctMoMember/deleteById',
        deleteBatch:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organizationMember/ctMoMember/deleteByIds',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organizationMember/ctMoMember/exportTemplateXls',
        importExcelUrl:
          process.env.VUE_APP_CMS_CUSTOMER +
          '/organizationMember/ctMoMember/importExcelx',
      },
      dictOptions: {},
      superFieldList: [],
    };
  },
  created() {
    this.organizationId = this.$route.query.id;
    this.searchReset();
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    },
  },
  methods: {
    //导入
    exportFile() {
      this.exportVisible = true;
    },
    handleOk() {
      this.handleChange();
      this.exportVisible = false;
    },
    handleCancel() {
      this.exportVisible = false;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    // 导出excel
    handleExportExcel(fileName) {
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }
      let param = { ...this.searchObj };
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        param['selections'] = this.selectedRowKeys.join(',');
      }
      console.log('导出参数', param);
      downFile(this.url.exportXlsUrl,param).then((data) => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    handleChange() {
      // const { file, fileList } = info;
      // let status = file.status;
      // if (status == 'done') {
      if (this.fileList.length == 0) {
        return;
      }
      let formData = new FormData();
      formData.set('file', this.fileList[0]);
      formData.set('organizationId', this.organizationId);
      uploadAction(this.url.importExcelUrl, formData)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.searchReset();
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.fileList = [];
          this.showDialog = false;
        });
    },
    //-----------------列表页重复代码-开始--------------
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    loadData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      getAction(this.url.list,params).then(res => {
        that.loading = true;
        if (res.success) {
          that.dataSource =
            res.result && res.result.records ? res.result.records : [];
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    getQueryParams() {
      let param = Object.assign(
        this.searchObj
      );

      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      let str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    handleAdd: function(course) {
      console.log(course);
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }

      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleEdit: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    handleDetail: function(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '详情';
      this.$refs.modalForm.disableSubmit = true;
    },
    handleDelete: function(id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      let that = this;
      postAction(that.url.delete, { id: id }).then(res => {
        if (res.success) {
          that.$message.success(res.message);
          that.loadData();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.name);
      if (this.name == 'courseManageModal') {
        let courseList = selectedRowKeys;
        this.form.setFieldsValue({
          courseList
        });
      }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    searchQuery() {
      this.loadData(1);
    },
    //重置
    searchReset() {
      this.searchObj = {organizationId:this.organizationId };
      this.loadData(1);
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(',') > 0) {
        text = text.substring(0, text.indexOf(','));
      }
      return getFileAccessHttpUrl(text);
    },
    //-----------------列表页重复代码-结束--------------
    backTap(){
      this.closeCurrent();
    }
  },
};
</script>
<style scoped lang="less">
@import '~@assets/less/common.less';
.backBtnBox {
  overflow: hidden;
  padding-bottom: 12px;
  button {
    float: right;
  }
}
</style>